import { useIsFeatureEnabled } from '../../../../feature-enablement/featureEnablement';

/**
 * One gate over the whole agentic lookup editor. The agent needs the chat drawer (`mr-fabry`) and
 * the V2 backend (`mr-fabry-coupacabry`), so all three flags are read — unconditionally, since an
 * `a() && b()` one-liner would short-circuit and break the rules of hooks.
 */
export const useIsLookupAgentEnabled = () => {
  const isFabryEnabled = useIsFeatureEnabled('mr-fabry');
  const isV2BackendEnabled = useIsFeatureEnabled('mr-fabry-coupacabry');
  const isLookupAgentEnabled = useIsFeatureEnabled('pat-645-lookup-agent');

  return isFabryEnabled && isV2BackendEnabled && isLookupAgentEnabled;
};
